// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pricing-section {
  width: 100%;
  background: #121212;
  color: #F1F1F1;
  padding: 120px 24px 96px;
  min-height: 100vh;
  font-family: "Satoshi", sans-serif;
}

.pricing-heading {
  text-align: center;
  max-width: 768px;
  margin: 0 auto 64px;
}

.pricing-title {
  font-size: 48px;
  font-weight: 500;
  margin: 8px 0 0;
  color: #F1F1F1;
  line-height: 1.2;
}

.pricing-subtitle {
  color: rgba(241, 241, 241, 0.6);
  margin-top: 16px;
  font-size: 18px;
  line-height: 1.5;
}

/* Toggle */
.pricing-toggle {
  position: relative;
  z-index: 20;
  margin-top: 24px;
  display: inline-flex;
  align-items: center;
  padding: 4px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 9999px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
}

.pricing-toggle-btn {
  padding: 8px 20px;
  border-radius: 9999px;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
  border: none;
  background: transparent;
  cursor: pointer;
  color: rgba(241, 241, 241, 0.6);
  font-family: "Satoshi", sans-serif;
}

.pricing-toggle-active {
  background: #CCFF00;
  color: #121212;
  box-shadow: 0 1px 3px 0 rgba(204, 255, 0, 0.3);
}

/* Grid */
.pricing-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 32px;
  max-width: 1152px;
  margin: 0 auto;
}

@media (min-width: 768px) {
  .pricing-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Card */
.pricing-card {
  position: relative;
  padding: 32px;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);
  background: rgba(255, 255, 255, 0.05);
}

.pricing-card-highlighted {
  border-color: #CCFF00;
  background: rgba(204, 255, 0, 0.1);
  box-shadow: 0 8px 24px rgba(204, 255, 0, 0.25);
  transform: scale(1.02);
}

/* Badge */
.pricing-badge {
  position: absolute;
  top: -16px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: fit-content;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pricing-badge-text {
  padding: 6px 16px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 9999px;
  background: rgb(86, 86, 86);
  color: #ccff00b3;
  border: 1px solid rgba(204, 255, 0, 0.113);
  white-space: nowrap;
}

/* Card Content */
.pricing-card-title {
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 8px;
  color: #F1F1F1;
}

.pricing-price {
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-bottom: 16px;
}

.pricing-price-amount {
  font-size: 36px;
  font-weight: 700;
  color: #F1F1F1;
}

.pricing-price-period {
  font-size: 14px;
  color: rgba(241, 241, 241, 0.6);
}

.pricing-card-description {
  margin-top: 16px;
  font-size: 14px;
  color: rgba(241, 241, 241, 0.6);
  line-height: 1.5;
}

/* Features */
.pricing-features {
  margin: 24px 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pricing-feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.pricing-check-icon {
  width: 16px;
  height: 16px;
  color: #CCFF00;
  flex-shrink: 0;
}

.pricing-feature-text {
  font-size: 14px;
  color: rgba(241, 241, 241, 0.8);
  line-height: 1.5;
}

/* CTA */
.pricing-cta {
  width: 100%;
  padding: 12px 24px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  font-family: "Satoshi", sans-serif;
}

.pricing-cta-highlighted {
  background: #CCFF00;
  color: #121212;
}

.pricing-cta-highlighted:hover {
  background: rgba(204, 255, 0, 0.8);
  color: #121212;
}

.pricing-cta-default {
  border: 1px solid rgba(255, 255, 255, 0.3);
  background: transparent;
  color: #F1F1F1;
}

.pricing-cta-default:hover {
  background: #CCFF00;
  color: #121212;
  border-color: #CCFF00;
}

/* Responsive */
@media (max-width: 768px) {
  .pricing-section {
    padding: 100px 16px 64px;
  }

  .pricing-title {
    font-size: 36px;
  }

  .pricing-subtitle {
    font-size: 16px;
  }

  .pricing-card {
    padding: 24px;
  }

  .pricing-price-amount {
    font-size: 32px;
  }
}

@media (max-width: 480px) {
  .pricing-section {
    padding: 80px 12px 48px;
  }

  .pricing-title {
    font-size: 28px;
  }

  .pricing-card {
    padding: 20px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/pages/pricing/pricing.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,wBAAwB;EACxB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,qBAAqB;EACrB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,8CAA8C;AAChD;;AAEA,SAAS;AACT;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,0CAA0C;EAC1C,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,8CAA8C;EAC9C,sBAAsB;AACxB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".pricing-section {\n  width: 100%;\n  background: #121212;\n  color: #F1F1F1;\n  padding: 120px 24px 96px;\n  min-height: 100vh;\n  font-family: \"Satoshi\", sans-serif;\n}\n\n.pricing-heading {\n  text-align: center;\n  max-width: 768px;\n  margin: 0 auto 64px;\n}\n\n.pricing-title {\n  font-size: 48px;\n  font-weight: 500;\n  margin: 8px 0 0;\n  color: #F1F1F1;\n  line-height: 1.2;\n}\n\n.pricing-subtitle {\n  color: rgba(241, 241, 241, 0.6);\n  margin-top: 16px;\n  font-size: 18px;\n  line-height: 1.5;\n}\n\n/* Toggle */\n.pricing-toggle {\n  position: relative;\n  z-index: 20;\n  margin-top: 24px;\n  display: inline-flex;\n  align-items: center;\n  padding: 4px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 9999px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);\n}\n\n.pricing-toggle-btn {\n  padding: 8px 20px;\n  border-radius: 9999px;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  color: rgba(241, 241, 241, 0.6);\n  font-family: \"Satoshi\", sans-serif;\n}\n\n.pricing-toggle-active {\n  background: #CCFF00;\n  color: #121212;\n  box-shadow: 0 1px 3px 0 rgba(204, 255, 0, 0.3);\n}\n\n/* Grid */\n.pricing-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 32px;\n  max-width: 1152px;\n  margin: 0 auto;\n}\n\n@media (min-width: 768px) {\n  .pricing-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n/* Card */\n.pricing-card {\n  position: relative;\n  padding: 32px;\n  border-radius: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  transition: all 0.3s ease;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.3);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.pricing-card-highlighted {\n  border-color: #CCFF00;\n  background: rgba(204, 255, 0, 0.1);\n  box-shadow: 0 8px 24px rgba(204, 255, 0, 0.25);\n  transform: scale(1.02);\n}\n\n/* Badge */\n.pricing-badge {\n  position: absolute;\n  top: -16px;\n  left: 0;\n  right: 0;\n  margin-left: auto;\n  margin-right: auto;\n  width: fit-content;\n  pointer-events: none;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.pricing-badge-text {\n  padding: 6px 16px;\n  font-size: 12px;\n  font-weight: 500;\n  border-radius: 9999px;\n  background: rgb(86, 86, 86);\n  color: #ccff00b3;\n  border: 1px solid rgba(204, 255, 0, 0.113);\n  white-space: nowrap;\n}\n\n/* Card Content */\n.pricing-card-title {\n  font-size: 20px;\n  font-weight: 500;\n  margin-bottom: 8px;\n  color: #F1F1F1;\n}\n\n.pricing-price {\n  display: flex;\n  align-items: baseline;\n  gap: 8px;\n  margin-bottom: 16px;\n}\n\n.pricing-price-amount {\n  font-size: 36px;\n  font-weight: 700;\n  color: #F1F1F1;\n}\n\n.pricing-price-period {\n  font-size: 14px;\n  color: rgba(241, 241, 241, 0.6);\n}\n\n.pricing-card-description {\n  margin-top: 16px;\n  font-size: 14px;\n  color: rgba(241, 241, 241, 0.6);\n  line-height: 1.5;\n}\n\n/* Features */\n.pricing-features {\n  margin: 24px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.pricing-feature-item {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.pricing-check-icon {\n  width: 16px;\n  height: 16px;\n  color: #CCFF00;\n  flex-shrink: 0;\n}\n\n.pricing-feature-text {\n  font-size: 14px;\n  color: rgba(241, 241, 241, 0.8);\n  line-height: 1.5;\n}\n\n/* CTA */\n.pricing-cta {\n  width: 100%;\n  padding: 12px 24px;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  border: none;\n  cursor: pointer;\n  font-family: \"Satoshi\", sans-serif;\n}\n\n.pricing-cta-highlighted {\n  background: #CCFF00;\n  color: #121212;\n}\n\n.pricing-cta-highlighted:hover {\n  background: rgba(204, 255, 0, 0.8);\n  color: #121212;\n}\n\n.pricing-cta-default {\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  background: transparent;\n  color: #F1F1F1;\n}\n\n.pricing-cta-default:hover {\n  background: #CCFF00;\n  color: #121212;\n  border-color: #CCFF00;\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .pricing-section {\n    padding: 100px 16px 64px;\n  }\n\n  .pricing-title {\n    font-size: 36px;\n  }\n\n  .pricing-subtitle {\n    font-size: 16px;\n  }\n\n  .pricing-card {\n    padding: 24px;\n  }\n\n  .pricing-price-amount {\n    font-size: 32px;\n  }\n}\n\n@media (max-width: 480px) {\n  .pricing-section {\n    padding: 80px 12px 48px;\n  }\n\n  .pricing-title {\n    font-size: 28px;\n  }\n\n  .pricing-card {\n    padding: 20px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
